import PropTypes from 'prop-types';

// These functions are used in MediocrePlugins.getTableItemProps and tableEditablePropsFromEditor,
// which are used by DataTableEditable. DataTableEditable is used in AssayGroupResultsTable,
// which uses SpreadsheetEvalMixin, which provides these methods. When SpreadsheetEvalMixin
// is fully replaced with withSpreadsheetEvaluation, this mixin can be removed.

const WithSpreadsheetEvaluationUserMixin = {
  propTypes: {
    extraUsedTableNames: PropTypes.func,
    getAllStoreDependenciesFromSpreadsheetRoot: PropTypes.func,
    getContent: PropTypes.func.isRequired,
    getSpreadsheetTableName: PropTypes.func.isRequired,
    getItems: PropTypes.func.isRequired,
    getRoot: PropTypes.func.isRequired,
    getSpreadsheetEvalCacheKey: PropTypes.func,
    getType: PropTypes.func.isRequired,
    itemsAccessor: PropTypes.func.isRequired,
    makeFullTableMap: PropTypes.func.isRequired,
    selectorsFromProps: PropTypes.func.isRequired,
    setContent: PropTypes.func.isRequired,
    spreadsheetRoot: PropTypes.func.isRequired,
    spreadsheetTypes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    updateRoot: PropTypes.func.isRequired,
    evaluateTables: PropTypes.func.isRequired,
    setMultiEditingForTable: PropTypes.func.isRequired,
    tryInsert: PropTypes.func.isRequired,
    canInsert: PropTypes.func.isRequired,
    disallowMultiExpand: PropTypes.func.isRequired,
    performTableOp: PropTypes.func.isRequired,
    updateSelectors: PropTypes.func.isRequired,
    usedTableNames: PropTypes.func.isRequired,
    isTableNameUsed: PropTypes.func.isRequired,
  },

  getRoot(props) {
    return this.props.getRoot(props);
  },

  getCid(item) {
    return this.props.getCid(item);
  },

  getContent(item) {
    return this.props.getContent(item);
  },

  getSpreadsheetTableName(item) {
    return this.props.getSpreadsheetTableName(item);
  },

  setMultiEditingForTable({tableName, documentName}, args) {
    this.props.setMultiEditingForTable({tableName, documentName}, args);
  },

  tryInsert({tableName, documentName}, e) {
    return this.props.tryInsert({tableName, documentName}, e);
  },

  canInsert(e) {
    return this.props.canInsert(e);
  },

  performTableOp({tableName, op, options}) {
    this.props.performTableOp({tableName, op, options});
  },

  isTableNameUsed(tableName) {
    return this.props.isTableNameUsed(tableName);
  },

  getDataForTableItemProps() {
    return {
      tableNamespace: this.props.tableNamespace,
      showExcessLabels: this.props.showExcessLabels,
      computedTables: this.props.computedTables,
      cellColors: this.props.cellColors,
      editingTable: this.props.editingTable,
      selectorCounts: this.props.selectorCounts,
      fullTableMap: this.props.fullTableMap,
    };
  },
};

export default WithSpreadsheetEvaluationUserMixin;
